export const identity = {
    yourIdentity: {
        revealIdentity: 'Identität des Hinweisgebers',
        yesRevealIdentity: 'Ja, ich möchte meine Identität offenlegen',
        noDontRevealIdentity: 'Nein, ich möchte anonym bleiben',
    }
};
